import { ServiceSelectItem } from "components/ServiceSelectItem";
import { Text } from "components/shared/text";
import React from "react";
import { useSalesNetwork } from "utils/hooks/useSalesNetworks";

export const NewStudy: React.FC = () => {
  const { network } = useSalesNetwork();

  return (
    <group
      data-space-vertical="40"
      data-gap="24"
      data-length="350"
      data-direction="column"
    >
      <Text data-text-size="22" data-wrap="wrap" data-color="grey-color-dark">
        FO_DOC_NEW_STUDY
      </Text>
      {network?.services.map((service) => (
        <ServiceSelectItem key={service.code} service={service} />
      ))}
    </group>
  );
};
